/*
 * @Description:
 * @Date: 2021-06-17 15:05:33
 */

import dateFormat from '@/tools/dateFormat';
import rowLink from '@/components/Base/baseRowlink.js';
import orderDetailPayProgress from '../../orderDetailPayProgress/index.vue';

export default {
  createDt: {
    label: '生成时间',
    prop: 'createDt',
    formatter(r, c, v) {
      return dateFormat(v) || '-';
    }
  },
  // 结算-订单详情-人员支付进度 !!需要两层数据
  orderDetailPayProgress: {
    label: '支付进度',
    render: function(h, ctx, r) {
      const vm = ctx.parent;
      const { projectId, projectIndustryFenpeiId, orderId } = r;
      const showDialog = () => {
        const diglog = vm.$xrkDialog({
          title: '支付进度',
          width: '90vw',
          $slots: {
            default: h(orderDetailPayProgress, {
              props: {
                row: {
                  projectId,
                  projectIndustryFenpeiId,
                  orderId
                }, // 当前
                rootRow: vm.defaultQuery // 父级
              }
            }),
            footer: h(
              'div',
              {
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '10px 50px'
                }
              },
              [
                h(
                  'el-button',
                  {
                    props: {},
                    on: {
                      click: () => {
                        diglog.remove();
                      }
                    }
                  },
                  '关闭'
                )
              ]
            )
          }
        });
      };
      return h(rowLink, {
        props: {
          text: `${r['payPeopleNum']}/${r['allPeopleNum']}`
        },
        on: {
          click: () => showDialog()
        }
      });
    }
  }
};
